import { Button, EmbeddedContentDefinition } from 'modules/graphql';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useState } from 'react';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { InputText } from 'ui/inputs';
import { Drag16, Edit16 } from 'ui/icons';
import { Key } from 'constants/keyCodes';
import { DISPLAY_CONTENT } from '../../constants';
import { ButtonNameWrapper, ReadOnly, TitleField, TitleWrapper } from './styles';

type Props = {
  button: Button;
  index: number;
};

export const TitleInput = ({ button, index }: Props) => {
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { elements } = liveTemplate.mediumData as EmbeddedContentDefinition;
  const actionButtons = elements?.buttons || [];
  const setActionButtons = (updatedActions: Button[]) => {
    const newElements = {
      ...elements,
      buttons: updatedActions,
    };
    setCurrentMediumField('elements', newElements);
  };
  const [isEditingTitle, setIsEditingTitle] = useState(false);

  const handleInputChange = (newTitle: string) => {
    const updatedList = [...actionButtons];
    const newActionButton = {
      ...button,
      title: newTitle,
    };
    updatedList[index] = newActionButton;
    setActionButtons(updatedList);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === Key.ENTER || event.key === Key.ESCAPE) {
      setIsEditingTitle(false);
    }
  };

  return (
    <TitleWrapper data-test="action-button-title-input" data-is-editing-title={isEditingTitle}>
      <Drag16 />
      <TitleField data-is-editing-title={isEditingTitle}>
        {isEditingTitle ? (
          <InputText
            data-test="title-input-text-field"
            autoFocus
            maxLength={100}
            onBlur={() => setIsEditingTitle(false)}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
            placeholder={DISPLAY_CONTENT.settings.actionButtonDefaultTitle}
            value={button.title || ''}
            width="100%"
          />
        ) : (
          <ButtonNameWrapper>
            <ReadOnly>{button.title || DISPLAY_CONTENT.settings.actionButtonDefaultTitle}</ReadOnly>
            <IconButton
              data-test="title-input-edit-button"
              onClick={() => setIsEditingTitle(true)}
              variant={BUTTON_VARIANTS.GHOST}
              size={BUTTON_SIZES.SMALL}
            >
              <Edit16 />
            </IconButton>
          </ButtonNameWrapper>
        )}
      </TitleField>
    </TitleWrapper>
  );
};
